import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mantine/core';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import { ECOM_IMAGE_POSITION_LIST } from '../../../config/constants';

const PrintDesignTemplatePositionControls = ({
  ecomExternalProduct,
  printTemplateState,
  onSwitchPrintImagePosition
}) => {
  const availablePositions = ecomExternalProduct
    ? ECOM_IMAGE_POSITION_LIST.filter((p) =>
        ecomExternalProduct.ecomExternalProductPrintTemplates.some(
          (t) => t.fkEcomImagePosition.toString() === p.value
        )
      )
    : [];

  return (
    availablePositions.length > 1 && (
      <AppStack
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <AppStack style={{ paddingBottom: 10 }}>
          <AppFlexbox
            style={{ gap: 10, alignItems: 'center', justifyContent: 'center' }}
          >
            {availablePositions.map((p) => {
              const selected =
                printTemplateState.fkEcomImagePosition?.toString() ===
                p.value.toString();

              return (
                <Button
                  key={p.value}
                  color="dark"
                  onClick={() => onSwitchPrintImagePosition(p.value)}
                  radius="xl"
                  style={{ minWidth: 100, pointerEvents: 'all' }}
                  variant={selected ? 'filled' : 'outline'}
                >
                  {p.label}
                </Button>
              );
            })}
          </AppFlexbox>
        </AppStack>
      </AppStack>
    )
  );
};

PrintDesignTemplatePositionControls.propTypes = {
  onSwitchPrintImagePosition: PropTypes.func.isRequired,
  printTemplateState: PropTypes.object.isRequired,
  ecomExternalProduct: PropTypes.object
};

export default PrintDesignTemplatePositionControls;
